import React, { ReactNode } from 'react';
import styles from '../../../../styles/PerformanceDashboard.module.css';

interface MetricCardProps {
  title: string;
  value: string | number;
  icon: ReactNode;
  subtext?: string;
  subtextWarning?: boolean;
  trend?: {
    value: string;
    isPositive: boolean;
  };
  iconColor?: string;
}

const MetricCard: React.FC<MetricCardProps> = ({
  title,
  value,
  icon,
  subtext,
  subtextWarning = false,
  trend,
  iconColor,
}) => {
  return (
    <div className={styles.metricCard}>
      <div className={styles.metricTitleRow}>
        <span className={styles.metricTitle}>{title}</span>
        <div className={styles.metricIconWrapper}>
          <div className={styles.metricIcon} style={iconColor ? { color: iconColor } : undefined}>
            {icon}
          </div>
        </div>
      </div>
      <div className={styles.metricValueRow}>
        <div className={styles.metricValue}>{value}</div>
        {trend && (
          <div className={styles.metricTrend} style={{ color: trend.isPositive ? '#10b981' : '#ef4444' }}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              {trend.isPositive ? (
                <polyline points="18 15 12 9 6 15"></polyline>
              ) : (
                <polyline points="6 9 12 15 18 9"></polyline>
              )}
            </svg>
            <span>{trend.value}</span>
          </div>
        )}
      </div>
      {subtext && (
        <div className={styles.metricFooter}>
          <div className={subtextWarning ? styles.metricSubtextWarning : styles.metricSubtext}>
            {subtext}
          </div>
        </div>
      )}
    </div>
  );
};

export default MetricCard;

